import { AiOutlineFileExcel, AiOutlineFilePdf } from 'react-icons/ai'
import { ContainerThatCloseOutside } from '../../../../ContainerThatCloseOutside'
import { useRef } from 'react'

import { Container, ExcelButton, PDFButton } from './style';


export function ExportFiles({ 
    handleDownloadCSV,
    fetchingCSVData = false, 
    pdfButtonIsVisible = false,
    setIsOpen, 
    pdfConverter,
    isOpen 
}) {
    const ref = useRef(null)


    if(isOpen){
        return (
            <ContainerThatCloseOutside
                handleClickOutside={() => setIsOpen(false)}
                availableToClick={isOpen}
                ref={ref}
            >
                <Container>

                    <ExcelButton
                        fetchingData={fetchingCSVData}
                        onClick={() => {
                            handleDownloadCSV()
                            setIsOpen(false)
                        }}
                    >
                        <AiOutlineFileExcel />
                        <p>Exportar Excel</p>
                    </ExcelButton>
                    
                    {
                        pdfButtonIsVisible && 
                        <PDFButton onClick={() => {
                            pdfConverter()
                            setIsOpen(false)
                        }}>
                            <AiOutlineFilePdf />
                            <p>Exportar PDF</p>
                        </PDFButton>
                    }

                </Container>
            </ContainerThatCloseOutside>
        )
    }
    else {
        return <></>
    }
}
